import { gql } from '@apollo/client';

export default gql`
  query GetFlatExperience($id: ID! = "", $slug: String! = "") {
    flatExperienceGroup(documentId: $id) {
      flat_experiences(filters: { slug: { eq: $slug } }) {
        title
        description_ck
        slug
        disableBookmarking
        image {
          url
        }
        desktopImage {
          url
        }
        mobileImage {
          url
        }
        carouselPosition
        image_carousel {
          carouselItems(pagination: { limit: 30 }) {
            image {
              url
            }
          }
        }
        keywords {
          keyword
        }
        bookmarkLinks {
          label
          externalUrl
        }
      }
    }
  }
`;
